module.exports = __webpack_public_path__ + "img/travel-ofs_0.c47afb0a.jpg";